import React, { createContext, useContext, useEffect } from 'react'
import { useOnboardingModal } from '../models/hooks/useOnboardingModal'
import { ONBOARDING_STEPS_TYPES } from '../constants'
import { useOnboardingConditions } from '../models/hooks/useOnboardingConditions'
import { useAppState, useContent, useChallenges } from '../../../redux/reducer/content'
import { ACHIEVEMENTS } from '../../../components/pages/challenges'
import useOnboardingInit from '../models/hooks/useOnboardingInit'
import { MAIN, INTERACTIVE_SHOP } from '../../../constants/shared/states/names'

export default function OnboardingProvider({ children }) {
  const { openOnboardingModal } = useOnboardingModal()
  const { isBath } = useContent()
  const { activeTab } = useChallenges()
  const state = useAppState()

  const { canStartOnboarding, isOnboardingAvailable, shouldShowOnboardingStep } =
    useOnboardingConditions()
  const isAchievementsOnMeAvailable = true

  useEffect(() => {
    if (!isOnboardingAvailable) return

    if (state === MAIN && canStartOnboarding) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.START)
    } else if (state === MAIN && shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.ACTIVITY)) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.ACTIVITY)
    } else if (
      state === INTERACTIVE_SHOP &&
      shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.SHOPPING)
    ) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.SHOPPING)
    } else if (
      activeTab === ACHIEVEMENTS &&
      shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.ACHIEVEMENTS) &&
      isAchievementsOnMeAvailable
    ) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.ACHIEVEMENTS)
    } else if (
      isBath &&
      state === MAIN &&
      shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.BEAUTY_ROUTINE)
    ) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.BEAUTY_ROUTINE)
    }
  }, [state, isBath, activeTab])

  useOnboardingInit()

  return (
    <OnboardingContext.Provider value={{ openOnboardingModal, shouldShowOnboardingStep }}>
      {children}
    </OnboardingContext.Provider>
  )
}

const OnboardingContext = createContext({})

export const useOnboardingContext = () => useContext(OnboardingContext)
